import { createContext, useState } from "react";
import { ShowEquipment } from "../api/api";
import FetchData from "./FetchData";

export const Context = createContext();
export const Provider = ({ children }) => {
  // window.addEventListener("resize", function () {
  //   const elements = document.querySelectorAll(
  //     '[dir="rtl"].layout-menu-fixed:not(.layout-menu-collapsed) .layout-page, [dir="rtl"].layout-menu-fixed-offcanvas:not(.layout-menu-collapsed) .layout-page'
  //   );
  //   if (this.window.innerWidth < 992) {
  //     elements.forEach((element) => {
  //       element.style.paddingRight = "0";
  //     });
  //   }
  //   if (this.window.innerWidth >= 992) {
  //     elements.forEach((element) => {
  //       element.style.paddingRight = "19.5rem";
  //     });
  //     document.querySelector("aside#menu-detail .state i.close").style.left =
  //       "-2.5rem";
  //     document.querySelector("aside#menu-detail").style.transform =
  //       "translateX(0)";
  //     setOpenDetailMenu(true);
  //   }
  // });

  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState(
    localStorage.getItem("get_notification_status"),
  );
  const [rooms, setRooms] = useState([]);
  const [scenarios, setScenarios] = useState([]);
  const [scenarioCommands, setScenarioCommands] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [equipmentButtons, setEquipmentButtons] = useState([]);
  const [currentRoom, setCurrentRoom] = useState();
  const [roomEquipments, setRoomEquipments] = useState([]);
  const [scenarioCommandDetail, setScenarioCommandDetail] = useState({});
  const [editEquipmentButton, setEditEquipmentButton] = useState(null);
  const [buttonShouldLearnCode, setButtonShouldLearnCode] = useState({});
  const [tvButtonShouldLearnCode, setTvButtonShouldLearnCode] = useState(null);
  const [tvButtons, setTvButtons] = useState([]);
  const [clickTvButton, setClickTvButton] = useState(false);
  const [wirelessKeyMode, setWirelessKeyMode] = useState(false);
  const [numberOfRgbColorPicker, setNumberOfRgbColorPicker] = useState(0);
  const [refreshMqtt, setRefreshMqtt] = useState(false);
  const [thermostatSetTempModalType, setThermostatSetTempModalType] =
    useState(null);
  const [changedName, setChangedName] = useState("");

  const [selectedEquipment, setSelectedEquipment] = useState({
    id: null,
    type: null,
  });
  const [page, setPage] = useState({
    name: "",
    slug: "",
  });

  const [settingsPage, setSettingsPage] = useState("");
  const [openDetailMenu, setOpenDetailMenu] = useState(true);
  const [backupModal, setBackupModal] = useState();
  const [numbersModal, setNumbersModal] = useState();
  const [learnCodeModal, setLearnCodeModal] = useState();
  const [selectEquipmentModal, setSelectEquipmentModal] = useState();
  const [equipmentsListModal, setEquipmentsListModal] = useState();
  const [equipmentsNameModal, setEquipmentsNameModal] = useState();
  const [scenarioNameModal, setScenarioNameModal] = useState();
  const [roomNameModal, setRoomNameModal] = useState();
  const [scenarioCommandInfoModal, setScenarioCommandInfoModal] = useState();
  const [scenarioTimerModal, setScenarioTimerModal] = useState();
  const [thermostatSetTempModal, setThermostatSetTempModal] = useState();
  const [equipmentButtonIconModal, setEquipmentButtonIconModal] = useState();
  const [changeNameModal, setChangeNameModal] = useState();
  const [setHumidityModal, setSetHumidityModal] = useState();
  const [SetDataFormat, setSetDataFormat] = useState();
  const [selectOutputEquipment, setSelectOutputEquipment] = useState();
  const [closeEquipmentListButton, setCloseEquipmentListButton] = useState();
  const [scenarioMode, setScenarioMode] = useState(false);
  const [scenarioEquipmentType, setScenarioEquipmentType] = useState(null);
  const [scheduleEquipmentType, setScheduleEquipmentType] = useState(null);
  const [scenarioEquipmentId, setScenarioEquipmentId] = useState(null);
  const [scheduleEquipmentId, setScheduleEquipmentId] = useState(null);
  const [editChartNumberModal, setEditChartNumberModal] = useState(null);
  const [defineChartModal, setDefineChartModal] = useState(null);
  const [chartModal, setChartModal] = useState(null);
  const [addDeviceModal, setAddDeviceModal] = useState(null);
  const [paymentAmountModal, setPaymentAmountModal] = useState(null);
  const [apiKeyModal, setApiKeyModal] = useState(null);
  const [scenarioIconModal, setScenarioIconModal] = useState(null);
  const [transactionsModal, setTransactionsModal] = useState(null);
  const [editScenarioIcon, setEditScenarioIcon] = useState(null);
  const [chartInfo, setChartInfo] = useState(null);
  const [helpContent, setHelpContent] = useState(null);
  const [changeNameOptions, setChangeNameOptions] = useState({
    name: null,
    onSubmit: null,
  });
  const [scenarioTimeCondition, setScenarioTimeCondition] = useState([]);
  const [addScenarioCommandDetail, setAddScenarioCommandDetail] = useState({
    scenario_id: null,
    device_id: null,
    command_name: null,
    data: null,
    icon: null,
    time: null,
  });
  const [authUser, setAuthUser] = useState(
    JSON.parse(localStorage.getItem("user")),
  );

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [addedTypeEquipment, setAddedTypeEquipment] = useState(null);

  const handleShowDetailMenu = () => {
    // const elements = document.querySelectorAll(
    //   '[dir="rtl"].layout-menu-fixed:not(.layout-menu-collapsed) .layout-page, [dir="rtl"].layout-menu-fixed-offcanvas:not(.layout-menu-collapsed) .layout-page',
    // );
    // elements.forEach((element) => {
    //   element.style.paddingRight = "19.5rem";
    // });
    // document.querySelector("aside#menu-detail .state i.close").style.left =
    //   "-2.5rem";
    // document.querySelector("aside#menu-detail").style.transform =
    //   "translateX(0)";
    // setOpenDetailMenu(true);
  };
  const handleHideDetailMenu = () => {
    // const elements = document.querySelectorAll(
    //   '[dir="rtl"].layout-menu-fixed:not(.layout-menu-collapsed) .layout-page',
    // );
    // elements.forEach((element) => {
    //   element.style.paddingRight = "4.5rem";
    // });
    // document.querySelector("aside#menu-detail .state i.open").style.left =
    //   "-7rem";
    // document.querySelector("aside#menu-detail").style.transform =
    //   "translateX(19.5rem)";
    // setOpenDetailMenu(false);
  };

  const handleShowBackupModal = () => {
    const modal = new window.bootstrap.Modal(backupModal.current);
    modal.show();
  };
  const handleNumbersModal = (status) => {
    const modal = new window.bootstrap.Modal(numbersModal.current);
    status ? modal.show() : modal.hide();
  };
  const handleLearnCodeModal = (status) => {
    const modal = new window.bootstrap.Modal(learnCodeModal.current);
    status ? modal.show() : modal.hide();
  };
  const handleSelectEquipmentModal = (status) => {
    const modal = new window.bootstrap.Modal(selectEquipmentModal.current);
    if (!status) {
      selectEquipmentModal.current.modal("hide");
    }
    status ? modal.show() : modal.hide();
  };
  const handleSelectOutputEquipmentModal = (status) => {
    const modal = new window.bootstrap.Modal(selectOutputEquipment.current);
    if (!status) {
      selectEquipmentModal.current.modal("hide");
    }
    status ? modal.show() : modal.hide();
  };
  const handleEquipmentsListModal = (status) => {
    const modal = new window.bootstrap.Modal(equipmentsListModal.current);
    if (!status) {
      selectEquipmentModal.current.modal("hide");
    }
    status ? modal.show() : modal.hide();
  };

  const handleEquipmentsNameModal = (status) => {
    const modal = new window.bootstrap.Modal(equipmentsNameModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleScenarioNameModal = (status) => {
    const modal = new window.bootstrap.Modal(scenarioNameModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleScenarioCommandInfoModal = (status) => {
    const modal = new window.bootstrap.Modal(scenarioCommandInfoModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleScenarioTimerModal = (status) => {
    const modal = new window.bootstrap.Modal(scenarioTimerModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleEquipmentButtonIconModal = (status) => {
    const modal = new window.bootstrap.Modal(equipmentButtonIconModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleThermostatSetTempModal = (status) => {
    const modal = new window.bootstrap.Modal(thermostatSetTempModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleSetHumidityModal = (status) => {
    const modal = new window.bootstrap.Modal(setHumidityModal.current);
    status ? modal.show() : modal.hide();
  };

  const handleChangeNameModal = () => {
    const modal = new window.bootstrap.Modal(changeNameModal.current);
    modal.show();
  };

  const handleSetDataFormat = () => {
    const modal = new window.bootstrap.Modal(SetDataFormat.current);
    modal.show();
  };

  const handleEditChartNumberModal = () => {
    const modal = new window.bootstrap.Modal(editChartNumberModal.current);
    modal.show();
  };

  const handleDefineChartModal = () => {
    const modal = new window.bootstrap.Modal(defineChartModal.current);
    modal.show();
  };

  const handleChartModal = () => {
    const modal = new window.bootstrap.Modal(chartModal.current);
    modal.show();
  };

  const handlePaymentAmountModal = () => {
    const modal = new window.bootstrap.Modal(paymentAmountModal.current);
    modal.show();
  };

  const handleAddDeviceModal = () => {
    const modal = new window.bootstrap.Modal(addDeviceModal.current);
    modal.show();
  };

  const handleApiKeyModal = () => {
    const modal = new window.bootstrap.Modal(apiKeyModal.current);
    modal.show();
  };

  const handleScenarioIconModal = () => {
    const modal = new window.bootstrap.Modal(scenarioIconModal.current);
    modal.show();
  };
  const handleTransactionsModal = () => {
    const modal = new window.bootstrap.Modal(transactionsModal.current);
    modal.show();
  };
  const handleRoomNameModal = () => {
    const modal = new window.bootstrap.Modal(roomNameModal.current);
    modal.show();
  };

  const [devices, setDevices] = useState([]);

  return (
    <Context.Provider
      value={{
        isLoading,
        setIsLoading,
        rooms,
        setRooms,
        page,
        setPage,
        openDetailMenu,
        setOpenDetailMenu,
        setBackupModal,
        handleShowBackupModal,
        settingsPage,
        setSettingsPage,
        authUser,
        setAuthUser,
        token,
        setToken,
        devices,
        setDevices,
        numbersModal,
        setNumbersModal,
        handleNumbersModal,
        learnCodeModal,
        setLearnCodeModal,
        handleLearnCodeModal,
        setSelectEquipmentModal,
        handleSelectEquipmentModal,
        setSelectOutputEquipment,
        handleSelectOutputEquipmentModal,
        currentRoom,
        setCurrentRoom,
        equipmentsListModal,
        setEquipmentsListModal,
        handleEquipmentsListModal,
        equipmentsNameModal,
        setEquipmentsNameModal,
        handleEquipmentsNameModal,
        addedTypeEquipment,
        setAddedTypeEquipment,
        closeEquipmentListButton,
        setCloseEquipmentListButton,
        equipments,
        setEquipments,
        equipmentButtons,
        setEquipmentButtons,
        roomEquipments,
        setRoomEquipments,
        selectedEquipment,
        setSelectedEquipment,
        scenarioMode,
        setScenarioMode,
        scenarioEquipmentType,
        setScenarioEquipmentType,
        scheduleEquipmentType,
        setScheduleEquipmentType,
        scenarioEquipmentId,
        setScenarioEquipmentId,
        scheduleEquipmentId,
        setScheduleEquipmentId,
        scenarioNameModal,
        setScenarioNameModal,
        handleScenarioNameModal,
        scenarios,
        setScenarios,
        scenarioCommands,
        setScenarioCommands,
        scenarioCommandInfoModal,
        setScenarioCommandInfoModal,
        handleScenarioCommandInfoModal,
        addScenarioCommandDetail,
        setAddScenarioCommandDetail,
        scenarioTimerModal,
        setScenarioTimerModal,
        handleScenarioTimerModal,
        scenarioCommandDetail,
        setScenarioCommandDetail,
        handleEquipmentButtonIconModal,
        equipmentButtonIconModal,
        setEquipmentButtonIconModal,
        editEquipmentButton,
        setEditEquipmentButton,
        update,
        setUpdate,
        buttonShouldLearnCode,
        setButtonShouldLearnCode,
        tvButtonShouldLearnCode,
        setTvButtonShouldLearnCode,
        clickTvButton,
        setClickTvButton,
        tvButtons,
        setTvButtons,
        setWirelessKeyMode,
        wirelessKeyMode,
        thermostatSetTempModal,
        setThermostatSetTempModal,
        handleThermostatSetTempModal,
        thermostatSetTempModalType,
        setThermostatSetTempModalType,
        setHumidityModal,
        setSetHumidityModal,
        handleSetHumidityModal,
        numberOfRgbColorPicker,
        setNumberOfRgbColorPicker,
        notificationStatus,
        setNotificationStatus,
        scenarioTimeCondition,
        setScenarioTimeCondition,
        changeNameModal,
        setChangeNameModal,
        handleChangeNameModal,
        changedName,
        setChangedName,
        changeNameOptions,
        setChangeNameOptions,
        setSetDataFormat,
        handleSetDataFormat,
        handleEditChartNumberModal,
        setEditChartNumberModal,
        handleDefineChartModal,
        setDefineChartModal,
        handleChartModal,
        setChartModal,
        chartInfo,
        setChartInfo,
        handlePaymentAmountModal,
        setPaymentAmountModal,
        handleAddDeviceModal,
        setAddDeviceModal,
        refreshMqtt,
        setRefreshMqtt,
        apiKeyModal,
        setApiKeyModal,
        handleApiKeyModal,
        helpContent,
        setHelpContent,
        scenarioIconModal,
        setScenarioIconModal,
        handleScenarioIconModal,
        editScenarioIcon,
        setEditScenarioIcon,
        transactionsModal,
        setTransactionsModal,
        handleTransactionsModal,
        handleRoomNameModal,
        setRoomNameModal,
      }}
    >
      <FetchData />
      {children}
    </Context.Provider>
  );
};
